import { createStyles, rem } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var radius = _ref.radius,
      shadow = _ref.shadow;
  return {
    dropdown: {
      position: "absolute",
      backgroundColor: theme.white,
      background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]),
      padding: "".concat(theme.spacing.sm, " ").concat(theme.spacing.md),
      boxShadow: theme.shadows[shadow] || shadow || "none",
      borderRadius: theme.fn.radius(radius),
      "&:focus": {
        outline: 0
      }
    },
    arrow: {
      backgroundColor: "inherit",
      border: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]),
      zIndex: 1
    }
  };
});
export default useStyles;